<template lang="pug">
.wrapper
    .container-full.p-4.m-auto
        //- Header Global
        HeaderGlobal(HeaderGlobalHeading="License" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading License Application
            .box__body
                .table-static.w-full.p-4.table-mobile.table-target
                    table.table-general
                        thead
                            tr
                                th License Serial Number
                                th License name
                                th Qty
                                th Server
                                th Status
                                th Start Date
                                th End Date
                        tbody
                            tr(v-for="item in dataLicense" :key="item.id")
                                td {{ item.serial }}
                                td {{ item.name }}
                                td {{ item.qyt }}
                                td {{ item.server }}
                                td 
                                    span.inline-block.bg-green-200.rounded.py-1.px-2.text-green-600.uppercase.text-center.font-bold.text-xs {{ item.status }}
                                td {{ item.start }}
                                td {{ item.end }}
</template>

<script>
import HeaderGlobal from '@/components/HeaderGlobal.vue'
export default {
    name: 'License',
    components: {
        HeaderGlobal,
    },
    data() {
        return {
            breadcrumb: [
                {
                    name: 'License',
                    url: '/license',
                },
            ],
            dataLicense: [
                {
                    serial: 'KOEV-CZJI-LKZP-BAII-TQIY-FELT-BAS1',
                    name: 'Proprietary Tracking System Licenses',
                    qyt: '1',
                    server: '69SVG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
                {
                    serial: 'BWRB-JRZK-IUIC-WVFF-ISSK-JELI-BAS2',
                    name: 'Proprietary Strategic Analysis Module System Licenses',
                    qyt: '1',
                    server: '69SRG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
                {
                    serial: 'CDXH-QWSM-BVNF-YKEP-NKTN-HELN-BAS3',
                    name: 'Unlimited Target License',
                    qyt: '1',
                    server: '69SRG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
                {
                    serial: 'GWCY-JIKA-KFPZ-VIJE-DBRR-PELD-BAS4',
                    name: 'Single Tracking License (10 numbers/day)',
                    qyt: '1',
                    server: '69SVG53',
                    status: 'Activated',
                    start: '30 Dec 2020',
                    end: '20 Dec 2023',
                },
                {
                    serial: 'BJAO-ZZMF-PUXV-AKNT-XGWQ-NELX-BAS5',
                    name: 'Multitracking License (Concurrent 3 numbers/day)',
                    qyt: '1',
                    server: '69SVG53',
                    status: 'Activated',
                    start: '30 Dec 2020',
                    end: '20 Dec 2023',
                },
                {
                    serial: 'CRUW-IILE-TIZA-RSNA-NTIZ-TELN-BAS6',
                    name: 'User License',
                    qyt: '1',
                    server: '69SRG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
                {
                    serial: 'PTRI-INTN-SNTA-HSBL-PLPA-LUCK-BAS6',
                    name: 'User License',
                    qyt: '1',
                    server: '69SRG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
                {
                    serial: 'TOTN-WIJY-RAIN-MNTS-INSA-JRTA-BAS7',
                    name: 'Tactical Locator Device License',
                    qyt: '1',
                    server: '69SRG53',
                    status: 'Activated',
                    start: 'Permanent',
                    end: 'Permanent',
                },
            ]
        }
    },
}
</script>